<template>
  <div>
    <!-- AppNavbar -->
    <app-navbar></app-navbar>

    <!-- Dashboard Container -->
    <div class="dashboard-container">
      <!-- AppSidebar -->
      <app-sidebar></app-sidebar>

      <slot></slot>
      <!-- <app-footer></app-footer> -->
    </div>
    <!-- Dashboard Container / End -->
  </div>
</template>

<script>
  /* eslint-disable no-console */

  // import { AppTopNavbar, AppBottomNavbar, AppFooter } from '../../partials/admin';
  import { AppNavbar, AppSidebar } from '../../partials/admin';
  export default {
    name: 'AdminDefault',
    components: {
      // AppTopNavbar,
      // AppBottomNavbar,
      // AppFooter,
      AppNavbar,
      AppSidebar,
    },

    data() {
      return {
        token: false,
      };
    },
  };
</script>

<style>
  .vh70 {
    min-height: 70vh;
  }
</style>
